export class ApplePayLineItem implements ApplePayJSV14.ApplePayLineItem {
	label: string;
	amount: string;
	type?: ApplePayJS.ApplePayLineItemType;
	paymentTiming?: ApplePayJSV14.ApplePayPaymentTiming;
	recurringPaymentStartDate?: Date;
	recurringPaymentEndDate?: Date;
	recurringPaymentIntervalUnit?: ApplePayJSV14.ApplePayRecurringPaymentDateUnit;
	recurringPaymentIntervalCount?: number;
	deferredPaymentDate?: Date;
}
